import * as actionType from '../action/auth/actionType';

const initialState = {
  systemLoading: false,
  userName: '',
  userId: '',
  loginStatus: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    // Update user info
    case actionType.UPDATE_USER_INFO:
      console.log('action',action);
      return {
        ...state,
        userName: action.payload.userName,
        userId: action.payload.userId,
        loginStatus: action.payload.loginStatus
      };
    case actionType.TOGGLE_SYSTEM_LOADING:
      return {
        ...state,
        systemLoading: action.payload.status,
      };

    default:
      return state;
  }
};
